import { render, staticRenderFns } from "./AddStockItem.vue?vue&type=template&id=3e1fe054&scoped=true&"
import script from "./AddStockItem.vue?vue&type=script&lang=js&"
export * from "./AddStockItem.vue?vue&type=script&lang=js&"
import style0 from "./AddStockItem.vue?vue&type=style&index=0&id=3e1fe054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1fe054",
  null
  
)

export default component.exports